module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADPSURBVHgB5VMxDsIwDHSrTqysdGWFPzDSvIaVkR+1KzN/YGWFFcZwFxlRheKkiK0nnZLW54vjJCIJeO83ZEpXShprcPUPoyxMxQinU0smYm0ZBfYYXYaJU239YVQUxQVDCzaWmcYaajUnoOqLEOgg5NRxxHdrmHT9WBWvGJvlmIQ8+b4FJjH5Ds7096CJaRSZmSbB6PUgIToaZg8jHvLZIz5KNmNQaFWhCPk8/qu8e/AL5sKKUdoSkx14U44BC1iAh9BsvaFbGV8ZFz5h++cnNStnM+ygoHwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/appxiazai.png
// module id = 838
// module chunks = 1